module.exports = __webpack_public_path__ + "static/media/65.11efc79e.jpg";